<p *ngIf="propExists(membership.membership_freeze_date)">
  Currently scheduled to be frozen on: <b>{{ dateStringFromISO8601(membership.membership_freeze_date) }}</b>
  <ng-container *ngIf="membership.membership_unfreeze_date">
    and unfrozen on: <b>{{ dateStringFromISO8601(membership.membership_unfreeze_date) }}</b>
  </ng-container>
</p>
<p *ngIf="!propExists(membership.membership_freeze_date)">
  Currently scheduled to be unfrozen on: <b>{{ dateStringFromISO8601(membership.membership_unfreeze_date) }}</b>
</p>

<div class="alert alert-danger" role="alert" *ngIf="errorMessage">
  {{ errorMessage }}
</div>
